import { IStaticPagesState } from './types';

export const SLICE_NAMESPACE = 'static-page';

export const staticPagesInitialState: IStaticPagesState = {
  sections: {
    loading: false,
    data: [],
  },
};
